import { Component, EventEmitter, inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { LocatePackage, RenameIssueFields } from '../../../modules/teams/interfaces/locate-package';
import { FormControl, FormGroup } from '@angular/forms';
import { CustomValidatorsService } from '../../services/custom-validators.service';
import { IssueNameErrors } from '../../enums/issue-name-errors';
import { debounceTime, distinctUntilChanged, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'mee-rename-issue',
  templateUrl: './rename-issue.component.html',
  styleUrls: ['./rename-issue.component.scss'],
})
export class RenameIssueComponent implements OnDestroy, OnInit, OnChanges {
  @Input() locatePackage: LocatePackage;
  @Output() renameIssueFieldsChange = new EventEmitter<RenameIssueFields>();
  readonly IssueNameErrors = IssueNameErrors;
  private destroy$ = new Subject<void>();
  private validatorsService = inject(CustomValidatorsService);

  issuesNameForm = new FormGroup(
    {
      IssueDisplayName: new FormControl<string>(''),
      IssueDisplayNamePlural: new FormControl<string>(''),
    },
    { validators: this.validatorsService.dependentIssueDisplayNameRequired() },
  );

  get isFormValid(): boolean {
    return this.issuesNameForm.valid;
  }

  ngOnInit(): void {
    this.issuesNameForm.patchValue(this.locatePackage);

    this.issuesNameForm.valueChanges
      .pipe(
        debounceTime(100),
        distinctUntilChanged(),
        tap((data: RenameIssueFields) => this.renameIssueFieldsChange.emit(data)),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.locatePackage && !changes.locatePackage.currentValue) {
      this.issuesNameForm.patchValue(
        {
          IssueDisplayName: '',
          IssueDisplayNamePlural: '',
        },
        { emitEvent: false },
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getFormError(error: IssueNameErrors): boolean {
    return this.issuesNameForm.hasError(error);
  }
}
